import { React, Fragment, useState } from "react";
import Contactbanner from "../../assets/images/skilled-entrepreneurs-viewing-their-digital-presence.avif";
import { FaSearch } from "react-icons/fa";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BlogCards from "./BlogCards";
import CustomBanner from "../../components/CustomBanner";
import { motion } from "framer-motion";
import { Head } from 'vite-react-ssg';

function Blogs() {

  const blogCategories = [
    "Mobile Applications",
    "Web Applications",
    "Hybrid Applications",
    "IoT Applications",
    "Integrated Systems",
    "CMS Development",
    "Graphic Designing",
    "UI/UX Designing",
    "Digital Marketing"
  ];
  const [blogCategory, setBlogCategory] = useState(blogCategories[0]);

  const handleChange = (event) => {
    setBlogCategory(event.target.value);
  };

   
  return (
    
    <Fragment>
       <Head>
         <title>Explore our insights on the latest industry trends </title>
         <meta
           name="description"
           content='Read our blogs on emerging technologies and digital business acumen for SMBs and SMEs.  '
         />
         <link rel="canonical" href="https://apptalyst.com/blogs" />
       </Head>
        <CustomBanner bgImg={Contactbanner}>
              <motion.h1 
           initial={{ opacity: 0, y: 40 }}         
      whileInView={{ opacity: 1, y: 0 }}       
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}   className="text-[36px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1] font-bold ">
                   Blogs
                 </motion.h1 >
             </CustomBanner>

      <section className="container my-20  ">
        {/* <div className="flex  flex-col  md:flex-row space-y-3  md:space-y-0 md:space-x-4">
           <div className='relative  w-full md:w-9/12   '>
        <input type="text" className='w-full bg-white h-12 border text-black  pl-4 placeholder:text-xl placeholder:text-[#b1b1b2] outline-none rounded-md  '    placeholder='Search...' style={{ boxShadow: '0px4px 10px rgba(0,0, 0, 0.15)' }}/>
        <div className='bg-primary px-4 py-3 inline-block absolute top-[2px] right-[2px] rounded-rsm'>
        <FaSearch  color='gray'  fontSize='20px' className='font-extralight'/>
        </div>
    </div>
    <Box sx={{ minWidth:120 }} className='w-full md:w-3/12 h-fit'>
    <Select
  value={blogCategory}
  onChange={handleChange}
  displayEmpty
  fullWidth
  variant="standard" 
  disableUnderline 
  MenuProps={{
    PaperProps: {
      sx: {
        mt: 1,  
        borderRadius: 1,
        boxShadow: 3,
      },
    },
  }}
  sx={{
    border: '1px solid #ecedf0',
    boxShadow: 0,
    borderRadius: 1,
    backgroundColor: '#fff',
    padding: '6px 12px',
    outline:'none',
    marginBottom:"10px",
    '&:focus': {
      outline: 'none',
    },
  }}>
        {blogCategories.map((val) => (
          <MenuItem
            key={val}
            value={val}
            disableRipple
            sx={{
              padding: '10px 16px',
              '&:hover': {
                backgroundColor: '#f1f1f1',
              },
               '&.Mui-selected': {
      backgroundColor: '#f3f4f6 !important',  
      fontWeight: 'bold',  
    },
              '&:last-child': {
                borderBottom: 'none',
              },
            }}
          >
            {val}
          </MenuItem>
        ))}
      </Select>
    </Box>
        </div> */}
        <div className=' my-20 md:my-32   '>
         <BlogCards/>
        </div>

      </section>

    </Fragment> 
  );
} 

export default Blogs;
